module.exports = __webpack_public_path__ + "static/media/tutorial-01.f79bf4c9.jpg";